import { h } from "harmaja"
import * as L from "lonna"
import { Table } from "../../../../common/src/domain"
import { SubmenuProps } from "./ContextMenuView"

// ponytail: text buttons; icons when the menu gets designed
export function tableMenu({ board, focusedItems, dispatch }: SubmenuProps) {
    const tables = L.view(focusedItems, (f) => f.items.filter((i): i is Table => i.type === "table" && !i.locked))
    const update = (fn: (cells: string[][]) => string[][]) => {
        dispatch({
            action: "item.update",
            boardId: board.get().id,
            items: tables.get().map((t) => ({ id: t.id, cells: fn(t.cells) })),
        })
    }
    const addRow = () => update((cells) => [...cells, cells[0].map(() => "")])
    const removeRow = () => update((cells) => (cells.length > 1 ? cells.slice(0, -1) : cells))
    const addCol = () => update((cells) => cells.map((row) => [...row, ""]))
    const removeCol = () => update((cells) => cells.map((row) => (row.length > 1 ? row.slice(0, -1) : row)))
    return L.view(tables, (ts) =>
        ts.length === 0
            ? []
            : [
                  <div className="icon-group table-menu">
                      <span className="icon text-icon" title="Add row" onClick={addRow}>
                          +R
                      </span>
                      <span className="icon text-icon" title="Remove last row" onClick={removeRow}>
                          −R
                      </span>
                      <span className="icon text-icon" title="Add column" onClick={addCol}>
                          +C
                      </span>
                      <span className="icon text-icon" title="Remove last column" onClick={removeCol}>
                          −C
                      </span>
                  </div>,
              ],
    )
}
